define("resources/vessels", function(){
    return {
        "1000mLFlask":{
            name: "1000 mL Flask",
            maxVolume: 1.05,
            icon: "styles/icons/1000mLFlask.svg",
            template: "app/scripts/templates/1000mLFlask.ejs",
            vesselClass: "flask",
            dimensions: [92, 145],
            pourDimensions: [147, 115],
            acceptPoint: [45, 5],
            pourPoint: [180, 110],
            pours: true,
            accepts: true,
            weight: 280,
            weightVariation: 10,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "250mLFlask":{
            name: "250 mL Flask",
            maxVolume: 0.2548,
            icon: "styles/icons/250mLFlask.svg",
            template: "app/scripts/templates/250mLFlask.ejs",
            vesselClass: "flask",
            dimensions: [57.96, 91.35],
            pourDimensions: [92.61, 72.45],
            acceptPoint: [30, 5],
            pourPoint: [130, 100],
            pours: true,
            accepts: true,
            weight: 100,
            weightVariation: 5,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "250mLStopperedFlask": {
            name: "250 mL Stoppered Flask",
            maxVolume: 0.2508,
            icon: "styles/icons/250mLFlask.svg",
            template: "app/scripts/templates/250mLStopperedFlask.ejs",
            vesselClass: "flask",
            dimensions: [57.96, 91.35],
            pourDimensions: [92.61, 72.45],
            acceptPoint: [30, 5],
            pourPoint: [130, 100],
            pours: true,
            accepts: true,
            weight: 110,
            weightVariation: 5,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "500mLFlask":{
            name: "500 mL Flask",
            maxVolume: .51948,
            icon: "styles/icons/500mLFlask.svg",
            template: "app/scripts/templates/500mLFlask.ejs",
            vesselClass: "flask",
            dimensions: [73, 115],
            pourDimensions: [118, 92],
            acceptPoint: [35, 5],
            pourPoint: [160, 110],
            pours: true,
            accepts: true,
            weight: 255,
            weightVariation: 10,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "2500mLBottle": {
            name: "2500 mL Bottle",
            maxVolume: 2.5,
            icon: "styles/icons/2500mLBottle.svg",
            template: "app/scripts/templates/2500mLBottle.ejs",
            vesselClass: "bottle",
            dimensions: [121, 227],
            pourDimensions: [250, 150],
            pourPoint: [270, 120],
            pours: true,
            accepts: false,
            weight: 700,
            weightVariation: 10,
            drop: .02,
            roundoffTolerance: .01,
            bunsen: false,
            scale: false
        },
        "100mLBottle": {
            name: "100 mL Bottle",
            maxVolume: 0.1,
            icon: "styles/icons/100mLBottle_black.svg",
            template: "app/scripts/templates/100mLBottle.ejs",
            vesselClass: "bottle",
            dimensions: [26, 82],
            pourDimensions: [66, 79],
            pourPoint: [68, 144],
            pours: true,
            accepts: false,
            weight: 54,
            weightVariation: 3,
            drop: .001,
            roundoffTolerance: .01,
            bunsen: false,
            scale: true
        },
        "3LCarboy": {
            name: "3 L Carboy",
            maxVolume: 3,
            icon: "styles/icons/3LCarboy.svg",
            template: "app/scripts/templates/3LCarboy.ejs",
            vesselClass: "carboy",
            dimensions: [149, 232],
            pourDimensions: [149, 232],
            pourPoint: [125, 300],
            pours: true,
            accepts: false,
            weight: 840,
            weightVariation: 10,
            drop: .01,
            roundoffTolerance: .01,
            bunsen: false,
            scale: false
        },
        "10mLGraduatedCylinder":{
            name: "10 mL Graduated Cylinder",
            maxVolume: .01096,
            icon: "styles/icons/10mLGraduatedCylinder.svg",
            template: "app/scripts/templates/10mLGraduatedCylinder.ejs",
            vesselClass: "graduatedCylinder",
            dimensions: [119.2, 110],
            pourDimensions: [54.4, 54.4],
            acceptPoint: [10, 5],
            pourPoint: [100, 95],
            pours: true,
            accepts: true,
            weight: 23,
            weightVariation: 2,
            drop: .0002,
            roundoffTolerance: .00001,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "25mLGraduatedCylinder":{
            name: "25 mL Graduated Cylinder",
            maxVolume: .02875,
            icon: "styles/icons/25mLGraduatedCylinder.svg",
            template: "app/scripts/templates/25mLGraduatedCylinder.ejs",
            vesselClass: "graduatedCylinder",
            dimensions: [128.8, 103.68],
            pourDimensions: [85.12, 85.12],
            acceptPoint: [15, 5],
            pourPoint: [130, 100],
            pours: true,
            accepts: true,
            weight: 39,
            weightVariation: 3,
            drop: .0002,
            roundoffTolerance: .00001,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "50mLGraduatedCylinder":{
            name: "50 mL Graduated Cylinder",
            maxVolume: .057,
            icon: "styles/icons/50mLGraduatedCylinder.svg",
            template: "app/scripts/templates/50mLGraduatedCylinder.ejs",
            vesselClass: "graduatedCylinder",
            dimensions: [142.24, 122.24],
            pourDimensions: [104.32, 104.32],
            acceptPoint: [20, 5],
            pourPoint: [140, 100],
            pours: true,
            accepts: true,
            weight: 71,
            weightVariation: 3,
            drop: .0002,
            roundoffTolerance: .00001,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "100mLGraduatedCylinder":{
            name: "100 mL Graduated Cylinder",
            maxVolume: .106,
            icon: "styles/icons/100mLGraduatedCylinder.svg",
            template: "app/scripts/templates/100mLGraduatedCylinder.ejs",
            vesselClass: "graduatedCylinder",
            dimensions: [142.24, 122.24],
            pourDimensions: [104.32, 104.32],
            acceptPoint: [20, 5],
            pourPoint: [140, 100],
            pours: true,
            accepts: true,
            weight: 93,
            weightVariation: 3,
            drop: .0002,
            roundoffTolerance: .00001,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },

        "250mLBeaker":{
            name: "250 mL Beaker",
            maxVolume: .25893,
            icon: "styles/icons/250mLBeaker.svg",
            template: "app/scripts/templates/250mLBeaker.ejs",
            vesselClass: "beaker",
            dimensions: [56, 78],
            pourDimensions: [70, 82],
            acceptPoint: [30, 10],
            pourPoint: [95, 100],
            pours: true,
            accepts: true,
            weight: 100,
            weightVariation: 10,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "600mLBeaker":{
            name: "600 mL Beaker",
            maxVolume: .61,
            icon: "styles/icons/600mLBeaker.svg",
            template: "app/scripts/templates/600mLBeaker.ejs",
            vesselClass: "beaker",
            dimensions: [71.68, 130],
            pourDimensions: [100.48, 133.76],
            acceptPoint: [35, 10],
            pourPoint: [115, 105],
            pours: true,
            accepts: true,
            weight: 230,
            weightVariation: 10,
            drop: .004,
            roundoffTolerance: .005,
            bunsen: true,
            scale: true
        },
        "1000mLBeaker":{
            name: "1000 mL Beaker",
            maxVolume: 1.05,
            icon: "styles/icons/1000mLBeaker.svg",
            template: "app/scripts/templates/1000mLBeaker.ejs",
            vesselClass: "beaker",
            dimensions: [92.16, 127.36],
            pourDimensions: [115.2, 133.76],
            acceptPoint: [45, 10],
            pourPoint: [125, 110],
            pours: true,
            accepts: true,
            weight: 280,
            weightVariation: 10,
            drop: .004,
            roundoffTolerance:.005,
            bunsen: true,
            scale: true
        },
        "FoamCup":{
            name: "Foam Cup",
            maxVolume: .20354,
            icon: "styles/icons/foamCup.svg",
            template: "app/scripts/templates/foamCup.ejs",
            vesselClass: "foamCup",
            dimensions: [44, 61],
            pourDimensions: [57, 65],
            acceptPoint: [20, 5],
            pourPoint: [90, 105],
            pours: true,
            accepts: true,
            weight: 9,
            weightVariation: 2,
            drop: .001,
            roundoffTolerance: .01,
            bunsen: false,
            scale: true
        },
        "WeighBoat":{
            name: "Weigh Boat",
            maxVolume: .0877,
            icon: "styles/icons/weighBoat.svg",
            template: "app/scripts/templates/weighBoat.ejs",
            vesselClass: "solid",
            dimensions: [67, 58],
            pourDimensions: [67, 58],
            acceptPoint: [35, 40],
            pourPoint: [85, 135],
            pours: true,
            accepts: true,
            weight: 4,
            weightVariation: 2,
            drop: .001,
            roundoffTolerance: .01,
            bunsen: false,
            scale: true
        },
        "SolidBottle":{
            name: "Solid Bottle",
            maxVolume: .1,
            icon: "styles/icons/solidBottle.svg",
            template: "app/scripts/templates/solidBottle.ejs",
            vesselClass: "solid",
            dimensions: [44, 81],
            pourDimensions: [134, 92],
            pourPoint: [150, 120],
            pours: true,
            accepts: false,
            weight: 54,
            weightVariation: 3,
            drop: .0005,
            roundoffTolerance: .01,
            bunsen: false,
            scale: true
        },
        "100mLVolumetricFlask":{
            name: "100 mL Volumetric Flask",
            maxVolume: .1033,
            icon: "styles/icons/100mLVolumetricFlask.svg",
            template: "app/scripts/templates/100mLVolumetricFlask.ejs",
            vesselClass: "volumetricFlask",
            dimensions: [147, 126],
            pourDimensions: [103, 103],
            pourPoint: [150, 95],
            acceptPoint: [25, 0],
            pours: true,
            accepts: true,
            weight: 51,
            weightVariation: 2,
            drop: .001,
            roundoffTolerance: .005,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "250mLVolumetricFlask":{
            name: "250 mL Volumetric Flask",
            maxVolume: .25565,
            icon: "styles/icons/250mLVolumetricFlask.svg",
            template: "app/scripts/templates/250mLVolumetricFlask.ejs",
            vesselClass: "volumetricFlask",
            dimensions: [159, 143],
            pourDimensions: [118, 118],
            pourPoint: [160, 95],
            acceptPoint: [30, 0],
            pours: true,
            accepts: true,
            weight: 94,
            weightVariation: 5,
            drop: .001,
            roundoffTolerance: .005,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "500mLVolumetricFlask":{
            name: "500 mL Volumetric Flask",
            maxVolume: .50964,
            icon: "styles/icons/500mLVolumetricFlask.svg",
            template: "app/scripts/templates/500mLVolumetricFlask.ejs",
            vesselClass: "volumetricFlask",
            dimensions: [172, 159],
            pourDimensions: [132, 132],
            pourPoint: [175, 95],
            acceptPoint: [40, 0],
            pours: true,
            accepts: true,
            weight: 167,
            weightVariation: 7,
            drop: .001,
            roundoffTolerance: .005,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "1000mLVolumetricFlask":{
            name: "1000 mL Volumetric Flask",
            maxVolume: 1.0157,
            icon: "styles/icons/1000mLVolumetricFlask.svg",
            template: "app/scripts/templates/1000mLVolumetricFlask.ejs",
            vesselClass: "volumetricFlask",
            dimensions: [184, 178],
            pourDimensions: [148, 148],
            pourPoint: [190, 95],
            acceptPoint: [40, 0],
            pours: true,
            accepts: true,
            weight: 222,
            weightVariation: 7,
            drop: .001,
            roundoffTolerance: .005,
            bunsen: false,
            scale: true,
            hasDetailView: true
        },
        "50mLBurette":{
            name: "50 mL Burette",
            maxVolume: .053,
            icon: "styles/icons/50mLBurette.svg",
            template: "app/scripts/templates/50mLBurette.ejs",
            vesselClass: "burette",
            dimensions: [128, 353],
            pourDimensions: [128, 353],
            pourPoint: [12, 400],
            acceptPoint: [12, 0],
            pours: true,
            accepts: true,
            weight: 71,
            weightVariation : 3,
            drop: .0001,
            roundoffTolerance: .000001,
            bunsen: false,
            scale: false,
            hasDetailView: true
        },
        "5mLPipette":{
            name: "5 mL Pipette",
            maxVolume: .0057,
            icon: "styles/icons/5mLPipette.svg",
            template: "app/scripts/templates/5mLPipette.ejs",
            vesselClass: "pipette",
            dimensions: [111, 160],
            pourDimensions: [111, 160],
            pourPoint: [4, 210],
            pours: true,
            accepts: false,
            weight: 20,
            weightVariation: 2,
            drop: .0001,
            roundoffTolerance: .000001,
            bunsen: false,
            scale: false,
            hasDetailView: true
        },
        "10mLPipette":{
            name: "10 mL Pipette",
            maxVolume: .0107,
            icon: "styles/icons/10mLPipette.svg",
            template: "app/scripts/templates/10mLPipette.ejs",
            vesselClass: "pipette",
            dimensions: [111, 160],
            pourDimensions: [111, 160],
            pourPoint: [4, 210],
            pours: true,
            accepts: false,
            weight: 30,
            weightVariation: 2,
            drop: .0001,
            roundoffTolerance: .000001,
            bunsen: false,
            scale: false,
            hasDetailView: true
        },
        "25mLPipette":{
            name: "25 mL Pipette",
            maxVolume: .027102,
            icon: "styles/icons/25mLPipette.svg",
            template: "app/scripts/templates/25mLPipette.ejs",
            vesselClass: "pipette",
            dimensions: [112, 160],
            pourDimensions: [112, 160],
            pourPoint: [5, 210],
            pours: true,
            accepts: false,
            weight: 40,
            weightVariation: 2,
            drop: .0001,
            roundoffTolerance: .000001,
            bunsen: false,
            scale: false,
            hasDetailView: true
        },
        "DisposablePipette":{
            name: "Disposable Pipette",
            maxVolume: .0018,
            icon: "styles/icons/DisposablePipette.svg",
            template: "app/scripts/templates/DisposablePipette.ejs",
            vesselClass: "pipette",
            dimensions: [6, 75],
            pourDimensions: [6, 75],
            pourPoint: [3, 125],
            pours: true,
            accepts: false,
            weight: 1,
            weightVariation: 1,
            drop: .0001,
            roundoffTolerance: .00001,
            bunsen: false,
            scale: false
        }
    }
});
